import ZepIcon from '@/icons/ZepIcon';

import { Value1 } from './Value1';
import { Value2 } from './Value2';
import { Value3 } from './Value3';

export const Value1Icon = ZepIcon(Value1);
export const Value2Icon = ZepIcon(Value2);
export const Value3Icon = ZepIcon(Value3);
